import { createContext } from 'react';

import type { User } from '@/api';

export interface UserContextState {
  user: User;
}

export const UserContext = createContext<undefined | UserContextState>(undefined);

UserContext.displayName = 'UserContext';
